import { memo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { Box, PressableIcon } from '@bonanza-social/moonlight';
import { selectHasPrizeWallCampaign } from '@bonanza-social/prize-wall/state';
import { PrizeWallCampaignHeader } from '@bonanza-social/prize-wall';

function PromosHeader({ onBackPress }: { onBackPress: () => void }) {
  const hasPrizeWallCampaign = useSelector(selectHasPrizeWallCampaign);

  if (hasPrizeWallCampaign) {
    return <PrizeWallCampaignHeader onBackPress={onBackPress} />;
  }

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      gap="space-400"
      paddingHorizontal={{
        mobile: 'space-400',
        tablet: 'space-400',
        desktop: 'space-1000',
      }}
      paddingVertical="space-200"
    >
      <PressableIcon
        width="space-600"
        name="arrowBack"
        gradient="accentBackground"
        onPress={onBackPress}
        testID="back-arrow-button"
      />
    </Box>
  );
}

export default memo(PromosHeader);
